(function () {
  if (window.innerWidth > 999) return;

  const body = document.body;
  const navigation = document.getElementById("main-navigation");
  const navbar = document.getElementById("main-navbar");
  const title = document.getElementById("main-navbar-title");
  const menu = document.getElementById("main-menu");
  const burger = document.querySelector(".burger");
  const menuItems = menu?.querySelectorAll("a") || [];
  const toggles = document.querySelectorAll("[data-js-navigation-toggle]");
  const btnBack = document.getElementById("main-menu-back");
  const btnClose = document.getElementById("main-navbar-close");

  if (!navigation || !navbar || !title || !menu || !burger) return;

  let currentLevel = 1;
  let menuStack = [];
  let titleStack = [];
  let currentMenu = null;

  const updateTitle = (newTitle) => {
    title.dataset.title = newTitle || "";
  };

  const resetMenuState = () => {
    currentLevel = 1;
    menuStack = [];
    titleStack = [];
    currentMenu = null;
    navbar.dataset.level = "1";
    navbar.dataset.submenuOpen = "false";
    menu.dataset.open = "false";

    menu.querySelectorAll(".sub-menu").forEach((submenu) => {
      submenu.setAttribute("data-open", "false");
    });

    updateTitle("");
  };

  const showNavigation = () => {
    navigation.dataset.visible = "true";
    navigation.dataset.open = "true";
    burger.classList.add("burger--close");
    body.classList.add("no-scroll");
    menu.dataset.open = "true";
  };

  const hideNavigation = () => {
    navigation.dataset.open = "false";
    navigation.dataset.visible = "false";
    burger.classList.remove("burger--close");
    body.classList.remove("no-scroll");
    resetMenuState();
  };

  const showSubmenu = (subMenu, clickedTitle) => {
    if (!subMenu) return;

    currentLevel++;
    menuStack.push(currentMenu);
    titleStack.push(clickedTitle);

    currentMenu?.setAttribute("data-open", "false");
    currentMenu = subMenu;
    subMenu.setAttribute("data-open", "true");
    navbar.dataset.level = String(currentLevel);
    navbar.dataset.submenuOpen = "true";

    updateTitle(clickedTitle);
  };

  const hideSubmenu = () => {
    if (currentLevel === 1) return;

    const previousMenu = menuStack.pop();
    const previousTitle =
      titleStack.length > 1 ? titleStack[titleStack.length - 2] : "";

    currentLevel--;
    titleStack.pop();

    currentMenu?.setAttribute("data-open", "false");
    if (previousMenu) {
      previousMenu.setAttribute("data-open", "true");
    }

    currentMenu = previousMenu;
    navbar.dataset.level = String(currentLevel);
    navbar.dataset.submenuOpen = currentLevel > 1 ? "true" : "false";
    updateTitle(previousTitle);
  };

  btnBack?.addEventListener("click", hideSubmenu);
  btnClose?.addEventListener("click", hideNavigation);

  toggles.forEach((toggle) => {
    toggle.addEventListener("click", (e) => {
      e.preventDefault();
      if (navigation.dataset.open === "true") {
        hideNavigation();
        return;
      }
      showNavigation();
    });
  });

  menuItems.forEach((item) => {
    const sibling = item.nextElementSibling;
    if (!sibling?.classList.contains("sub-menu")) return;

    item.addEventListener("click", (e) => {
      e.preventDefault();
      showSubmenu(sibling, item.textContent.trim());
    });
  });

  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape" && navigation.dataset.open === "true") {
      hideNavigation();
    }
  });
})();
